@if (show) {
    <div id="loading" class="boot-loader boot-loader--overlay" role="status" aria-live="polite">
        <div class="boot-loader__pulse-ring"></div>
        <img
            src="assets/images/PULSE_BY_CLUB_LOGO_POSITIVE_RGB.png"
            alt="Pulse"
            class="boot-loader__logo"
        />
        @if (text) {
            <span class="boot-loader__text">{{ text }}</span>
        }
    </div>
}
